import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, ImagePlus } from "lucide-react";
import { photoUrl } from "@/components/Portfolio";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ImageSetting = ({ settingKey, title, hint, value, arch = false, testId }) => {
    const [img, setImg] = useState(value || null);
    const [uploading, setUploading] = useState(false);
    const fileRef = useRef(null);

    useEffect(() => setImg(value || null), [value]);

    const upload = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setUploading(true);
        try {
            const fd = new FormData();
            fd.append("file", file);
            const up = await axios.post(`${API}/upload`, fd, { withCredentials: true });
            await axios.put(`${API}/settings/${settingKey}`, { value: up.data.url }, { withCredentials: true });
            setImg(up.data.url);
            toast.success("Foto aggiornata sul sito.");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Caricamento non riuscito.");
        } finally {
            setUploading(false);
            if (fileRef.current) fileRef.current.value = "";
        }
    };

    return (
        <div className="border border-stone-900/10 bg-white p-4" data-testid={testId}>
            <h3 className="font-display text-lg font-medium text-stone-900">{title}</h3>
            <p className="mt-1 text-xs leading-relaxed text-stone-500">{hint}</p>
            <div
                className={`relative mt-4 overflow-hidden border border-[#E75C15]/30 bg-stone-100 ${
                    arch ? "aspect-[3/4] max-w-[220px] rounded-t-[110px]" : "aspect-[4/3] max-w-[300px]"
                }`}
            >
                {img ? (
                    <img
                        src={photoUrl(img)}
                        alt={title}
                        data-testid={`${testId}-preview`}
                        className="h-full w-full object-cover"
                    />
                ) : (
                    <div className="flex h-full items-center justify-center px-4 text-center text-xs text-stone-400">
                        Foto attuale: quella predefinita del sito
                    </div>
                )}
            </div>
            <button
                data-testid={`${testId}-upload`}
                onClick={() => fileRef.current?.click()}
                disabled={uploading}
                className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#1C1917] px-6 py-3 text-xs font-medium uppercase tracking-wider text-stone-100 transition-colors hover:bg-[#B8430D] disabled:opacity-60"
            >
                {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ImagePlus className="h-4 w-4" />}
                {uploading ? "Caricamento…" : "Sostituisci la foto"}
            </button>
            <input
                ref={fileRef}
                type="file"
                accept="image/*"
                className="hidden"
                data-testid={`${testId}-input`}
                onChange={upload}
            />
        </div>
    );
};
